import { useState, useCallback, useEffect, useContext, createContext } from 'react';
import { generateUserAgentValues } from '@financial/app-js-interfaces';
import BottomLayer from './mo/BottomLayer.mjs';
import { QRBridge } from './pc/QRBridge.mjs';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const AppLinkerContext = /*#__PURE__*/createContext(null);
const AppLinkerProvider = _ref => {
  let {
    isShow,
    landingUrl,
    onClose,
    phase,
    serviceMenuOption,
    supportApps,
    naverAppDescription,
    payAppDescription,
    title,
    inappbrowser,
    applyShortenUrl,
    onNaverAppClick,
    onPayAppClick,
    children
  } = _ref;
  const [userAgent, setUserAgent] = useState();
  const [appLinkerState, setAppLinkerState] = useState({
    isShow,
    landingUrl,
    onClose,
    phase,
    serviceMenuOption,
    supportApps,
    naverAppDescription,
    payAppDescription,
    title,
    inappbrowser,
    applyShortenUrl,
    onNaverAppClick,
    onPayAppClick
  });
  const showAppLinker = useCallback(option => setAppLinkerState(prev => ({
    ...prev,
    ...option,
    isShow: true
  })), []);
  const hideAppLinker = useCallback(() => setAppLinkerState(prev => ({
    ...prev,
    isShow: false
  })), []);
  const handleClose = () => {
    hideAppLinker();
    appLinkerState.onClose?.();
  };
  useEffect(() => {
    const {
      isMobile,
      isIOS,
      isAndroid
    } = generateUserAgentValues(window.navigator.userAgent);
    setUserAgent({
      isMobile,
      isIOS,
      isAndroid
    });
  }, []);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(AppLinkerContext.Provider, {
      value: {
        showAppLinker,
        hideAppLinker
      },
      children: children
    }), userAgent ? userAgent.isMobile ? /*#__PURE__*/jsx(BottomLayer, {
      ...appLinkerState,
      isAndroid: userAgent.isAndroid,
      isIOS: userAgent.isIOS,
      onClose: handleClose
    }) : /*#__PURE__*/jsx(QRBridge, {
      ...appLinkerState,
      onClose: handleClose
    }) : null]
  });
};
const useAppLinker = () => {
  const context = useContext(AppLinkerContext);
  if (!context) {
    throw new Error('useAppLinker must be within AppLinkerProvider');
  }
  return context;
};

export { AppLinkerProvider, useAppLinker };
